import React, { useEffect, useState } from "react";
import Typewriter from "./components/Typewriter";
import './App.css'; // Import the CSS file

// Determine the base URL based on the environment
const baseURL = process.env.NODE_ENV === 'production'
  ? process.env.REACT_APP_PROD_BASE_URL
  : process.env.REACT_APP_DEV_BASE_URL;

const images = [
  `${baseURL}/assets/IMG_8389.mov.gif`,
  `${baseURL}/assets/img_3212.gif`,
  `${baseURL}/assets/IMG_1929.MOV.gif`,
  `${baseURL}/assets/IMG_2818.MOV.gif`,
  `${baseURL}/assets/IMG_3503.MOV.gif`,
  `${baseURL}/assets/IMG_4668.MOV.gif`,
  `${baseURL}/assets/IMG_0595.mov.gif`,
  `${baseURL}/assets/IMG_3205.MOV.gif`,
  `${baseURL}/assets/IMG_3673.MOV.gif`,
  `${baseURL}/assets/IMG_5087.MOV.gif`,
  `${baseURL}/assets/IMG_5994.MOV.gif`,
  `${baseURL}/assets/IMG_7158.MP4.gif`,
  `${baseURL}/assets/IMG_7239.MOV.gif`,
  `${baseURL}/assets/IMG_7291.mov.gif`,
  `${baseURL}/assets/IMG_8825.MOV.gif`,
  `${baseURL}/assets/IMG_8830.MP4.gif`,
  `${baseURL}/assets/IMG_8835.MP4.gif`,
  `${baseURL}/assets/IMG_8845.MOV.gif`,
  `${baseURL}/assets/IMG_0588.MOV.gif`,
  `${baseURL}/assets/IMG_7817.MP4.gif`,
  `${baseURL}/assets/IMG_7822.MP4.gif`,
  `${baseURL}/assets/IMG_7967.MP4.gif`,
  `${baseURL}/assets/IMG_7972.MP4.gif`,
  `${baseURL}/assets/IMG_8129.MP4.gif`,
  `${baseURL}/assets/IMG_8141.MP4.gif`,
  `${baseURL}/assets/IMG_8718.MP4.gif`,
  `${baseURL}/assets/IMG_8745.MP4.gif`,
  `${baseURL}/assets/IMG_8748.MP4.gif`,
  `${baseURL}/assets/IMG_8784.MP4.gif`,
  `${baseURL}/assets/IMG_8817.MP4.gif`,
  `${baseURL}/assets/IMG_8889.MP4.gif`,
  `${baseURL}/assets/IMG_8936.MP4.gif`,
  `${baseURL}/assets/IMG_9910.MP4.gif`,
  `${baseURL}/assets/IMG_5375.MP4.gif`,
  `${baseURL}/assets/IMG_5299.MP4.gif`,
  `${baseURL}/assets/IMG_5390.MOV.gif`,
  `${baseURL}/assets/IMG_9794.MOV.gif`,
  `${baseURL}/assets/IMG_5347.MP4.gif`,
  `${baseURL}/assets/IMG_5286.MP4.gif`,
  `${baseURL}/assets/IMG_5269.MP4.gif`,
  `${baseURL}/assets/IMG_7049.MP4.gif`,
  `${baseURL}/assets/IMG_9029.MOV.gif`,
  `${baseURL}/assets/IMG_1161.MOV.gif`,
  `${baseURL}/assets/IMG_2159.MOV.gif`,
  `${baseURL}/assets/IMG_0545.MP4.gif`,
  `${baseURL}/assets/IMG_0692.MOV.gif`,
  `${baseURL}/assets/IMG_7113.MOV.gif`,
  `${baseURL}/assets/IMG_9184.MOV.gif`,
  `${baseURL}/assets/IMG_0934.MOV.gif`,
  `${baseURL}/assets/IMG_7072.MP4.gif`,
  `${baseURL}/assets/IMG_1039.MOV.gif`,
  `${baseURL}/assets/IMG_8208.MOV.gif`,
  `${baseURL}/assets/IMG_0524.MP4.gif`,
  `${baseURL}/assets/IMG_6236.MP4.gif`,
  `${baseURL}/assets/IMG_0511.MP4.gif`,
  `${baseURL}/assets/IMG_7076.MOV.gif`,
  `${baseURL}/assets/IMG_0455.MP4.gif`,
  `${baseURL}/assets/IMG_0594.MP4.gif`,
  `${baseURL}/assets/IMG_0517.MP4.gif`,
  `${baseURL}/assets/IMG_6213.MP4.gif`,
  `${baseURL}/assets/IMG_0621.MP4.gif`,
  `${baseURL}/assets/IMG_0671.MOV.gif`,
  `${baseURL}/assets/IMG_0703.MP4.gif`,
  `${baseURL}/assets/IMG_6242.MP4.gif`,
  `${baseURL}/assets/IMG_7041.MP4.gif`,
  `${baseURL}/assets/IMG_0271.MOV.gif`,
  `${baseURL}/assets/IMG_6303.MOV.gif`,
  `${baseURL}/assets/IMG_6080.MP4.gif`,
  `${baseURL}/assets/IMG_0646.MP4.gif`,
  `${baseURL}/assets/IMG_6121.MP4.gif`,
  `${baseURL}/assets/IMG_0546.MP4.gif`,
  `${baseURL}/assets/IMG_0387.MOV.gif`,
  `${baseURL}/assets/IMG_0486.MP4.gif`,
  `${baseURL}/assets/IMG_6274.MOV.gif`,
  `${baseURL}/assets/IMG_4385.MP4.gif`,
  `${baseURL}/assets/IMG_0731.MP4.gif`,
  `${baseURL}/assets/IMG_3179.MP4.gif`,
  `${baseURL}/assets/IMG_4434.MP4.gif`,
  `${baseURL}/assets/IMG_3772.MOV.gif`,
  `${baseURL}/assets/IMG_3391.MOV.gif`,
  `${baseURL}/assets/IMG_3627.MP4.gif`,
  `${baseURL}/assets/IMG_3070.MP4.gif`,
  `${baseURL}/assets/IMG_3501.MOV.gif`,
  `${baseURL}/assets/video_1_3d5ac1882a9142cf95aa2aae3347db55.mp4.gif`,
  `${baseURL}/assets/IMG_4386.MP4.gif`,
  `${baseURL}/assets/IMG_4043.mov.gif`,
  `${baseURL}/assets/IMG_3568.MOV.gif`,
  `${baseURL}/assets/IMG_3713.MP4.gif`,
  `${baseURL}/assets/IMG_3705.MOV.gif`,
  `${baseURL}/assets/IMG_4185.MOV.gif`,
  `${baseURL}/assets/IMG_2717.MP4.gif`,
  `${baseURL}/assets/IMG_4191.MP4.gif`,
  `${baseURL}/assets/IMG_0632.MP4.gif`,
  `${baseURL}/assets/IMG_0195.MP4.gif`,
  `${baseURL}/assets/IMG_3964.MP4.gif`,
  `${baseURL}/assets/IMG_0144.MP4.gif`,
  `${baseURL}/assets/IMG_1061.MP4.gif`,
  `${baseURL}/assets/IMG_3135.MP4.gif`,
  `${baseURL}/assets/IMG_0650.MOV.gif`,
  `${baseURL}/assets/IMG_4018.MP4.gif`,
  `${baseURL}/assets/IMG_3926.MP4.gif`,
  `${baseURL}/assets/_talkv_wwcBjs3DFJ_YPenkKQ4kdFQwbfslxfPak_talkv_high.mp4.gif`,
  `${baseURL}/assets/IMG_3524.MOV.gif`,
  `${baseURL}/assets/IMG_3461.MP4.gif`,
  `${baseURL}/assets/IMG_3476.MP4.gif`,
  `${baseURL}/assets/IMG_9842.MP4.gif`,
  `${baseURL}/assets/IMG_3677.MOV.gif`,
  `${baseURL}/assets/IMG_4276.MOV.gif`,
  `${baseURL}/assets/IMG_0597.MOV.gif`,
  `${baseURL}/assets/IMG_4158.MOV.gif`,
  `${baseURL}/assets/IMG_0748.MP4.gif`,
];

function Home() {
  const content = [
    { type: "text", value: "To: Sarah Hahn" },
    { type: "text", value: "Date: 2025-30-01" },
    { type: "text", value: "Location: Bedford-Stuyvesant, Brooklyn, NY" },
    { type: "text", value: "Subject: Cakes and Candles" },
    { type: "text", value: "" },
    { type: "text", value: "" },
    { type: "text", value: "Twenty-seven! It's hard to believe that you're now older than me when we first met." },
    { type: "text", value: "I've been going back and forth on what to get you for your birthday and ultimately decided to make you some memorabilia of our time together. This is the result. I'd like to think that decades from now, we'll return to this page and reminisce on this time in life. Someone once said we have that 'first love' type of love, and I believe it's a fitting description of how we feel about each other. I hope this page serves as a capsule of that feeling whenever we look back on it. I love you so, so much and can't wait to spend a weekend celebrating your birthday." },
    { type: "text", value: "Enjoy memory lane." },
    { type: "text", value: "" },
    { type: "text", value: "" },
    { type: "text", value: "" },
    {
      type: "image",
      src: `${baseURL}/assets/image.png`,
      alt: "Exciting GIF",
      className: "image"
    },
    { type: "text", value: "This might be the earliest photo of us. The plan was to cook at your place and drink some wine. I remember there was a friend visiting you and your roommates and I felt quite uncomfortable especially with her snapping photos. I vividly remember not wanting to be in a photo out of awkwardness. Looking back  though, I'm glad this exists. In a way I'd like to think our relationship is still exactly as it is in this photo." },
    {
      type: "image",
      src: `${baseURL}/assets/birthday_long_ago.png`,
      className: "image"
    },
    { type: "text", value: "This must have been my 27th birthday? Kind of wild to think that we were already celebrating birthdays that early into knowing each other. I mostly remember Jordan just so happened to be there lol." },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_3281.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "In the beginning, hanging out mostly meant drinking, waking up hungover, then walking from your apartment to Chik-Fil-A. I remember when capturing this photo you said you were feeling quite blessed. You look quite blessed in this photo."
    },
    {
      type: "image",
      src: `${baseURL}/assets/lbi_early.png`,
      className: "image"
    },
    {
      type: "text",
      value: "Our first trip to LBI. I remember being so excited to show you the place I spent my summers growing up. So much ahppened this trip, I was in the middle of interviewing for jobs (I distinctly remember getting a call from a recruiter on the beach) but more importantly this was the first time we said I love you."
    },
    {
      type: "image",
      src: `${baseURL}/assets/img_3212.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "First trip to LBI. Basketball's been life"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0593.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "We pretend to not like karaoke but I feel like it's the greatest thing ever when we're together."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_2673.heic.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "City streets was pretty magical. Robi + Biking + Summer. Unreal"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4283.heic.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "This fit goes crazy but more importantly this was Christmas and the first time you met my family. They were incredibly impressed at your manners + you helping with cleaning after dinner. I think prior to our relationship, I never thought about the way a partner could enhance my own relationship/time I spent with my family — spending Christmas with you + parents + brother + aunt + uncle + cousins + their kids was wonderful."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4261.heic.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "First time you met Dominic."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4322.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Our first trip upstate. Foreshadowing of things to come."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4308.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Inness!!!!"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_2807.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Tending to a fire at Inness, no one else was around, just you and me <3."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4648.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Birthday trip KFC shennanigans. This is when I first learned about your love for mashed potatoes."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4717.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Fire in Vermont for your birthday trip."
    },
    {
      type: "image",
      src: `${baseURL}/assets/sarah_bday.png`,
      className: "image"
    },
    {
      type: "text",
      value: "Iconic t shirts for your birthday."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_5994.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "I'm not sure I even remember exactly when this was. I think we may have been dogsitting at this time because I remember having to leave this party to go to Classon, then we can back to party."
    },
    {
      type: "image",
      src: `${baseURL}/assets/vaguelye_remember.png`,
      className: "image"
    },
    {
      type: "text",
      value: "We really should make these burgers again. These look dank."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_6331.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "Jona's wedding! We were supposed to drive up with Pri and Graham but unfortunately Pri got covid so we ended up taking their car and just driving ourselves. I remember I was really stressed about driving 6h to Vermont lol. Also I remember the car breaks did not work well and tbh it was scawy. The wedding was quite fun though."
    },
    {
      type: "image",
      src: `${baseURL}/assets/jona_wedding1.png`,
      className: "image"
    },
    {
      type: "text",
      value: "The first appearance of this iconic dress. "
    },
    {
      type: "image",
      src: `${baseURL}/assets/jona2.png`,
      className: "image"
    },
    {
      type: "text",
      value: "The first appearance of this iconic suit. "
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_8085.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Dragged you to Wisconsin for Wendel's wedding. Never knew you took this photo. Kinda iconic that I'm wearing my middle school soccer jersey."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_6678.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "I have made you a park person :)."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_8389.mov.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "Playing with Robi and Vito in Fort Greene! Looking back at it we definitely were not supposed to take the dogs off the leash haha."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_6747.heic.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Fourth of July at loveless coffee! You look so good in this dress, I won't let you give it away solely because this photo."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_3029.heic.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Fourth of July on Brandon and Lydia's rooftop. You got quite drunky that day and we dangerously biked home. I think it was also a work night lol so some poor choices were made."
    },

    {
      type: "image",
      src: `${baseURL}/assets/IMG_7158.MP4.gif`,
      className: "image",
    },
    {
      type: "text",
      value: "Hiking to a waterfall with Dominic and Damian in Hawaii. They've grown up so much since then and it hasn't even been that long!"
    },

    {
      type: "image",
      src: `${baseURL}/assets/IMG_7291.mov.gif`,
      className: "image",
    },
    {
      type: "text",
      value: "Pololū Valley. Hawaii was so much fun. You met the whole fam and I mean the whole fam."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_8825.MOV.gif`,
      className: "image",
    },
    {
      type: "text",
      value: "Waterfall whose name I do not remember."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_8830.HEIC.jpg`,
      className: "image",
    },
    {
      type: "text",
      value: "Hilo was one of my favorite parts of the trip, solely because of the food. This mochi was so good."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_8835.HEIC.jpg`,
      className: "image",
    },
    {
      type: "text",
      value: "Me on a payphone outside Suisan"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_8845.MOV.gif`,
      className: "image",
    },
    {
      type: "text",
      value: "Where we ate Suisan. I think that place is the best poke I've ever had. Not sure it's even close."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0588.MOV.gif`,
      className: "image",
    },
    {
      type: "text",
      value: "Another day of the boba bears walking around propsect park."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_7817.MP4.gif`,
      className: "image",
    },
    {
      type: "text",
      value: "Biking — Frank Ocean"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_8141.MP4.gif`,
      className: "image",
    },
    {
      type: "text",
      value: "Rooftop party, I don't remember the details though of why we were there lol."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_8784.MP4.gif`,
      className: "image",
    },
    {
      type: "text",
      value: "Bb loves her cakes."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_9056.HEIC.jpg`,
      className: "image",
    },
    {
      type: "text",
      value: "Ski/snowboard trip to Stowe with my friends."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4019.HEIC.jpg`,
      className: "image",
    },
    {
      type: "text",
      value: "Work from home at Hudson Wilder."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_7822.HEIC.jpg`,
      className: "image",
    },
    {
      type: "text",
      value: "Propsectus!!!"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_8817.HEIC.jpg`,
      className: "image",
    },
    {
      type: "text",
      value: "Bb looks so cute on her birthday with her cake from harbs that we had to pickup because your friends were lazy (jk)."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_9129.HEIC.jpg`,
      className: "image",
    },
    {
      type: "text",
      value: "Is there a photo that better encapsulates what it was like to hang out at 275 together? Side note: I still get so sad every time I see these glasses :(. Was robbed by Men's wearhouse employee."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4248.HEIC.jpg`,
      className: "image",
    },
    {
      type: "text",
      value: "Scarr's Pizza at the original location before it was gentrified and while it was still a `hack` to ask for a table to skip the entire line."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_8129.MP4.gif`,
      className: "image",
    },
    {
      type: "text",
      value: "Grrahhh grahhhh pew pew buh buh buh baby doing a dance."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_8936.MP4.gif`,
      className: "image",
    },
    {
      type: "text",
      value: "Pictured: us in Jersey City and Lyle's wedding in our favorite wedding attire. Not pictured: your ranging hangover because the day before you got a little to drunky and yelled at me for letting your friend's friend's friends get the friend's friend an ambulance cuz she was drunk for her bday (you said I was elitist)."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_9136.HEIC.jpg`,
      className: "image",
    },
    {
      type: "text",
      value: "Bubsicle at the cliffs playing with a dog instead of climbing."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4265.HEIC.jpg`,
      className: "image",
    },
    {
      type: "text",
      value: "Double fisting some boots! I forgot when we went but I think this is the beer garden near the Whitney Museum."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_7967.MP4.gif`,
      className: "image",
    },
    {
      type: "text",
      value: "Ohhhh baby :(. Sorry if this embarasses you but how can I not include this. La Cabra had just opened and the plan was to go visit, later we were supposed to go to a party. But sadly you hit a big bump while biking there and this was the result. Thankfully you were okay and we made it to La Cabra. We didn't go to the party though, ended up going to Cervo's instead haha."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_8745.HEIC.jpg`,
      className: "image",
    },
    {
      type: "text",
      value: "Gallery day! Seeing some Cy Twombly"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_8889.HEIC.jpg`,
      className: "image",
    },
    {
      type: "text",
      value: "Hmmmm I think this is on the way to Lyle's wedding as well? Otherwise I'm not sure what this is."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_5269.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Upstate NY for our Second Anniversary!! Rented a car and an airbnb in Beacon. The airbnb was the best part of the whole stay."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_9910.MP4.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "A common motiff is fires + upstate NY."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_5375.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Blue Hill Farm but for lunch! Tbh this was pretty cool."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_5286.MP4.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "Beacon NY + Rainbow"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_9714.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "The flowers they bloom in Bed Stuy."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_5347.MP4.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "Vino outdoors in our beautiful beacon airnb."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_5299.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Brekkie in our beautiful beacon airnb."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_5390.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "Apple munchin @ Blue Hill Farms"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_9794.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "Wow so many memories of our anniversay trip to Beacon!"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_6080.MP4.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "The morning right after my birthday/after we went out I was still feeling spicy! Here is me drinking a Michelada in the new Bed Stuy apartment! Some key details: presents in the background, the new speakers are still on the floor and I haven't gotten the concrete blocks yet, I don't have those red side tables anyomre, I gave that painting to Alex."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_8163.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Blurry night walk on the beach in LBI! I hope I am reuinted with this sweater I am wearing one day."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_1913.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "A covid stricken Sarah Hahn navigates a park in Montreal. Prior to, she was deado but she has risen because she must meet her parents."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_9267.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Canada at some point after the covid had subsided."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_1926.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Cafe Olympico in Mile End, Montreal."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_9232.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Lac Tremblant"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0703.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "These are elite chairs. Also I taught you the art of pulling up your chair as close to the water with beverages in hand :)."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_7049.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "A happy boba bear in LBI."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_7276.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Hyunsun's rooftop in Park Slope."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_9029.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "Killing time while waiting for the airbnb to open and your parents to land. Here we're on St. Helen's Island in Montreal. Behind is the St. Lawrence river."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_9343.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Boba bears in Quebec City."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_1040.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Elegant Sarah Hahn."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_7041.MP4.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "Squish."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_1161.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "Bb with a sporty quiet luxury look in Beach Haven, Long Beach Island, NJ."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_1077.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Moodyman at 99 Scott but Moodman came on too late and we went home early."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_2139.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "You look like a French explorer. Made your money off of the beaver trade and looking for a route to India."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_2159.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "The Hahn family."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0545.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Dog sitting, your part time full time job."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0692.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "Going to LBI with you never gets old."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0517.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "This should be your profile photo for rover. Look how happy those boys are!"
    },

    {
      type: "image",
      src: `${baseURL}/assets/IMG_7113.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "10/10 beach fit. Peep the leopard hat."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_9184.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "Swimming in Lac Tremblant, maybe one of the best things I've ever done in my life tbh. Had covid all week so it felt good to be out and active."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0934.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "Layyyyyluuuhhh @ Do not feed the alligators"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_7072.MP4.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "Aye aye captain."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_2001.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Another day, another park, another beer in hand."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_1153.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "My baby."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_1039.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "This is Cinema."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0486.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Couldn't piece together why this photo looked so odd, but it's because we have none of the items that will come to define this room yet! Rugs are not there, the Akari lamp is not there. Everything looks so bare."
    },

    {
      type: "image",
      src: `${baseURL}/assets/IMG_8208.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "Is LBI the number one location in these photos?"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0794.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Another day, another park, part 2423"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0646.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Literally the largest oysters I've ever seen/eaten. This ruined oysters for me for a few weeks."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0524.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "bb + robi"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_6236.MP4.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "Random hike we did upstate with Joce + Rad. We got lost and did not make it to whatever we were trying to get to. Found this resevoir instead."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_8275.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Squishing in LBI.."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0983.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Adit's party I think. Theme was hawaiian?"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_2102.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "About to take a quick dip in the freezing but refreshing Canadian water. "
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0621.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Frog wine bar, the greatest wine bar in NYC."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_7927.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Hanging up a painting. Booty popping out. Go Bucks!"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_7076.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "Bike ridke through Beach Haven."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_9174.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Peak luxury."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_9080.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Photo of your parents through the window at Joe Beef. We had covid so we wanted to eat separately but also we wanted to eat Joe Beef so logically we asked to split our reservation."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_8435.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Park + wine + bb + colina strada pants."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_6213.MP4.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "Layluhhhhhh on a hike with us upstate."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0671.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "Run away from the cold water!!!"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_1946.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Market in montreal."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0271.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "Had super gentrified bad Korean food earlier this night. Then we went to a bar somewhere in Park Slope and got quite lit."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_6303.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "So much happened on this day! We rented a Uhaul, then met Kevin in Tribeca so he could help me move this insanely heavy credenza down two flights of stairs which almost killed us. Took this all the way back to Bed-Stuy, I hit a bus with my mirror. This was our first day at Rollo's and also someone tried to rob us when we were getting home. All-in-all a great/iconic day. "
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_9075.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Joe Beef, about to order a Jura Wine."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0546.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "The dog photos are endless!"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_2200.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "An incredibly hard to find restaurant in Quebec City."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_2167.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "About to check out of Hôtel Quintessence in Mont Tremblant.Probably the best hotel I've ever been to."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_2140.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Peep the covid mask cuz we're still a little sick while traveling in Canada."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_1969.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "`Fresh garlic from Quebec`"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0387.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "Taking Layla upstate via Metro North."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_6274.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "I miss these Manhattan rooftops."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_8991.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "OSMO X MARUSAN Café-Terrasse in Montreal. Our first stop as soon as we got off the plane. Were you still drinking coffe at this point in time?"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4385.MP4.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "View from our airbnb in Costa Rica."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_2367.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Our housewarming party."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_3588.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Roscquito in trouble. We were in California staying at my Aunt's place and we went to walk their dogs, but Rosco the rascal slipped out from his leash and started running around. He was just playing but there was a moment where it was like `omg are we going to lose my aunts dog`. Thankfully we caught up to him and you carried him the rest of the way. "
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0731.MP4.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "You + Karen, we're leaving Hyunsun's going away party and going to a rave at K under the bridge."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0748.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Graham coming in clutch with the beers. I remember the liens to get drinks at this rave were sooooo long. The whole thing was kinda a mess."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_3964.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Biggg brrrrr in the big city"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_3179.MP4.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "Koweaaa! You accidentally bought a very cute but a very impractical bag at this store. It did not fit your phone."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_3713.MP4.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "Is there a more iconic photo of our trip to the Philippines? Palawan was so beautiful and our tour guides were amazing. Here we are just chilling on a sandbar drinking some San Mig Light."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4434.MP4.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "Chilling by the pool in Costa Rica."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_3772.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "@sanmiguel please sponsor us"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0195.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Bb post half marathon after no training. You simultaneously slayed but were also slain."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_2544.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Poulette CPH. This is the European experience."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_3642.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "Morgan's wedding in California 2024. These wedding outfits are still ever present and relevant."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4099.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "At this point I realize I should probably put some years on some of these. Here we are the Henson in 2024! This was a celebration for you getting a new job. This whole hotel was beautiful. I think maybe my favorite upstate trip to date. "
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_3391.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "You + Jaquie in Apgujeong after eating pufferfish and discussing why men like Kanye West."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_3627.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[2023] Everything's better in the Philippines."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_3070.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[2023] My first trip to Korea! Iconic photo of bb Sarah Hahn. "
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_3501.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "[2023] Partying on Christmas Eve with your friends at Times in Apgu. "
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_3346.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[2024] Second time in Korea having chimaek! Major yomzzz but we played ourselves by not getting the spicy chicken. "
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_5772.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[2024] Second time in Korea, us getting dressed up for Maggie's wedding."
    },
    {
      type: "image",
      src: `${baseURL}/assets/video_1_3d5ac1882a9142cf95aa2aae3347db55.mp4.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "[2024] Seoul."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_6053.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[2024] Korean Frieze Week."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4386.MP4.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "[Spring 2024] Bb waking up to another beautiful morning in Costa Rica."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_3926.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Winter 2023] Harlan and Holden @ BGC in Manila."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4043.mov.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "[Summer 2024] Jumping into the Copenhagen harbor. Bath house designed by Bjarke Ing. Foreshadowing."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4194.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Fall 2024] Hiking upstate in the Catskills. Right after this photo you got scared that we'd run into a bear so then I got scared so then we left."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0632.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Summer 2024] Beautiful time in storm king with the doggies. Some lady tried to kick us out cuz we had the dogs off the leash so William claimed Vito could early detect heart failure so that we could stay. Also you all wouldn't stop complaining about the bugs lol."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_6011.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Summer 2024] Chimaek! Chimaek! Chimaek!"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_5781.heic.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Summer 2024] Maggie's wedding"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_2854.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Unknown] Lower eastside girly"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_3568.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "[Summer 2024] Orange County, California staying at my aunts place, hanging out with their dogs."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4325.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Fall 2024] Gina and Williams' engagement party"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_3705.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "[Winter 2023] Speedboating through Palawan."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4223.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Fall 2024] Colgate Lake, Catskills."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4185.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "[Early 2024, Winter] Rolling a big ball of snow through Propsect Park!"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_3153.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Summer 2024] Maggie's wedding ft. the sole Don Julio bottle left."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_3562.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Fall 2024] Taco Mesita — Santa Ana, California. This food was soooo good. We were going to try another place but decided to just come here twice. "
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0144.MP4.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "[Unknown] Boba bears under the cherry blossoms in Prospect Park."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_2717.MP4.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "[Fall 2023] NJ @ Rachel's wedding. Beautiful venue."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_2524.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Fall 2024] Kongens Have, the `King's Garden`. Beautiful weather + hotdogs + bike riding."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_2992.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Summer 2024] Some thrift store in soho. I went to Raku after this."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_2583.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Summer 2024] Copenhagen, right before I got my pants stuck in my bike and I had to strip in the middle of the Danish streets."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_5942.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Summer 2024] Seoul Palace!!! Korea was sooooo hot. We were supposed to meet up with a friend for drinks that night but we were both deado. We just had some delicious Japanese food for dinner and went to bed. "
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_3598.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Fall 2024] Laguna Beach day trip on the way to Morgan's wedding."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_6022.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Summer 2024] On our way to a Frieze party in Korea."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_3476.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[December 2023] Christmas eve out partying @ times in apgu."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_2494.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[July 2024] Bike riding through CPH."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_5898.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[August 2024] Boba bear under the boba bear sign in Seoul!"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0754.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Spring 2024] I think this was in the spring...I can't quite remember but this is peggy @ under the k bridge."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_1061.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Summer 2024] Cherry on top rooftop bar in Bushwick. This was the day you cried because you were very upset about your job :(. It was quite sad."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_3135.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[December 2023] At some wine bar you wanted to go to in Seoul. It was quite mid and it was freezing cold and I remember you were kinda dying after this restaurant. I remember we were taking the train back and we had to get off the train for you to make an emergency pit stop in the bathroom. I just sat on a bench in a foreign country and I felt like a little boy just waiting for his mom to come back cuz I was so lost. "
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4242.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Fall 2024] Outside at the Henson, getting drunk off of some Pepin vin. I think this was my favorite part of the trip. Either this or the lake not too sure. "
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4018.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Unknown] I forget exactly when this was but this day was so much fun. It was freezing but it had just snowed so we decided to go for a little adventure in propsect park. We brought a bottle of wine and just ended up drinking in the snow at the park. So much fun!!!"
    },
    {
      type: "image",
      src: `${baseURL}/assets/_talkv_wwcBjs3DFJ_YPenkKQ4kdFQwbfslxfPak_talkv_high.mp4.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "[August 2024] I was not feeling very cute so I really was against the idea of doing a photobooth. But I got roped into it and I think I had the most fun. I <3 photo booths now."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_2409.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Fall 2023] After math of our houswarming party."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_5911.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[August 2024] Bopping around Seoul, visting cafes and such. Yummy coffee."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_3524.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "[December 2023] You and Jane outside of Times on Christmas Eve. There was some drama about a coat so it hink you felt bad for Jane and were trying to warm her up or something? I'm not sure haha."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_3461.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[December 2023] Pregame before Times at a bar in Apgu. It's quite fun to go to places that you used to hang out in HS. I feel like an honorary SIS kid. "
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_2605.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[October 2023] Halloweeeeeennnnnnnnnn"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_9842.MP4.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "[Fall 2023] Newark Cathedral for Rachel's wedding. This wedding convinced me that I like Catholic weddings. So grandiose and dramatic. "
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_5871.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Summer 2024] Being a menance on the Seoul metro."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4064.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Fall 2024] Pepin Vin + Bibibimbop"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_6178.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Summer 2024] Walking Maui in California. Maui has such a scrunched face, so cute. "
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4276.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "[Fall 2024] Dancing with the flames at the Henson <3 <3 <3"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_0597.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "[Summer 2024] Galivanting through Storm King Art Center with Gina."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_2961.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Summer 2024] LBI but at this ice cream shop where they sing showtunes and make you participate. You were a victim, I was not."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4573.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Fall 2024] Jocelyn's Birthday. I got quite drink after this and puked everywhere because I tried zyn's firs the first time :facepalm:"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_2850.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Unknown] Lower eastside girly pt ii"
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_4158.MOV.gif`,
      className: "image"
    },
    {
      type: "text",
      value: "[Fall 2024] A casual stroll in the garden of the Henson."
    },
    {
      type: "image",
      src: `${baseURL}/assets/IMG_2551.HEIC.jpg`,
      className: "image"
    },
    {
      type: "text",
      value: "[Summer 2024] Doing the same shit, drinks + parks + vino but this time in CPH."
    },

  ];

  const [backgroundImage, setBackgroundImage] = useState("");

  useEffect(() => {

    const changeBackground = () => {
      const randomImage = images[Math.floor(Math.random() * images.length)];
      setBackgroundImage(randomImage);
    };

    changeBackground();
    const intervalId = setInterval(changeBackground, 4000);

    return () => clearInterval(intervalId); // Clean up interval on component unmount
  }, []);

  return (
    <div>
      <div
        className="fullscreen-background"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      ></div>
      <div
        className="content-container"
      >
        <Typewriter content={content} speed={5} />
      </div>
    </div>
  );
}


function App() {
  return (
    <Home />
  );
}

export default App;
